import type { ObjectInventoryField } from '@/entities/Inventory/ObjectTypes'
import { isFieldMandatory } from './validateMandatoryFields'

/**
 * Объединяет несколько коллекций метаданных полей по id (последний источник побеждает).
 * Для флага `mandatory` используется OR-семантика: если хотя бы один источник
 * пометил поле обязательным, результат сохраняет `mandatory: true`.
 */
export function mergeFieldMetadata(
  ...collections: (ObjectInventoryField[] | null | undefined)[]
): ObjectInventoryField[] {
  const fields = new Map<string, ObjectInventoryField>()
  collections.flat().forEach((field) => {
    if (!field) return
    const id = String(field.id)
    const existing = fields.get(id)
    if (existing && isFieldMandatory(existing.mandatory) && !isFieldMandatory(field.mandatory)) {
      fields.set(id, { ...field, mandatory: true })
    } else {
      fields.set(id, field)
    }
  })
  return [...fields.values()]
}
